import {setupAjaxConfiguration} from "ajaxSetup";
import router from 'routers/content.router';

require('js/traits/google-analytics');

setupAjaxConfiguration(router, (jqXHR) => jqXHR.status !== 413).then(() => console.log("Ajax setup done."));